import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import { IconCol, MobileCard } from "./Section1";

export const PayService = ({
  refs,
}: {
  refs: {
    payment: React.RefObject<HTMLDivElement>;
    payService: React.RefObject<HTMLDivElement>;
    settle: React.RefObject<HTMLDivElement>;
    merchant: React.RefObject<HTMLDivElement>;
    sales: React.RefObject<HTMLDivElement>;
  };
}) => {
  const isMobile = useResponsiveMobile(900);
  return (
    <div
      id="payment-system"
      className="flex flex-col gap-[80px] md:gap-[56px] xl:px-0"
      ref={refs.payService}
    >
      {/* 결제 서비스 소개글 */}
      <div className="flex flex-col gap-[32px] md:gap-[40px]">
        <div className="flex flex-col gap-[12px]">
          <h1 className="font-bold text-[36px] md:text-display flex items-center gap-[4px]">
            {isMobile && (
              <img
                width="48"
                height="48"
                alt="결제 서비스"
                src="/assets/images/icon/sidenav_payment.png"
              />
            )}
            결제 서비스
          </h1>
          <span className="font-semibold text-[18px] md:text-[20px] text-[#0079FF]">
            현장에 맞는 결제 방식, 모두 품에 있습니다.
          </span>
        </div>

        {isMobile ? (
          <span className="font-normal text-[#4D4F58] text-[16px] leading-[1.5]">
            품(Poom)은 온라인부터 현장, 수기, 문자 결제까지 비즈니스 현장에 필요한 모든 결제 방식을
            유연하게 지원합니다.
            <br />
            <br />
            온·오프라인의 경계 없이 모든 거래 과정을 하나로 연결하여, 어떤 환경에서도 끊김 없는 결제
            경험을 제공합니다.
          </span>
        ) : (
          <span className="font-normal text-[#4D4F58] text-[12px] md:text-[18px] leading-relaxed">
            품(Poom)은 온라인부터 현장, 수기, 문자 결제까지 {isMobile && <br />} 비즈니스 현장에
            필요한 모든 결제 방식을 유연하게 지원합니다. 온·오프라인의 경계 없이 모든 거래 과정을
            하나로 연결하여, {isMobile && <br />}어떤 환경에서도 끊김 없는 결제 경험을 제공합니다.
          </span>
        )}
      </div>

      {/* 결제 서비스 흐름 */}
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <div className="flex flex-row gap-3 items-center">
            <img width={24} height={24} src="/assets/images/icon/flow.png" alt="flow" />
            <span className="text-[20px] md:text-[28px] font-normal">결제 서비스 흐름</span>
          </div>
          <span className="text-[16px] md:text-[18px] font-normal text-[#4D4F58]">
            품 결제 서비스 흐름에 대해 자세히 알려드려요
          </span>
        </div>

        {/* 결제 서비스 흐름 이미지 */}
        <div className="w-full max-w-full overflow-hidden min-w-0 relative">
          {isMobile && (
            <div className="pointer-events-none absolute top-3 right-10 flex justify-center z-10 bg-black/50 px-3 py-1 rounded-full w-[fit-content]">
              <span className="text-[16px] text-white">↔ 좌우로 넘겨보세요</span>
            </div>
          )}
          <div className="w-full overflow-x-auto overflow-y-hidden overscroll-x-contain md:overflow-x-hidden">
            <div className="w-[1246px] md:w-full">
              <img
                src={"/assets/images/introduction/eg3.png"}
                alt="eg1"
                className="block w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>

      {/* 카드 섹션 */}
      <div className="md:hidden flex flex-col gap-[24px]">
        <div className="flex flex-col gap-[8px]">
          <span className="font-bold text-[#121319] text-[18px]">
            품에서 제공하는 결제 서비스를 확인하세요
          </span>
          <span className="font-normal text-[#4D4F58] text-[16px]">
            온 오프라인 상관없이 유연하게 연결합니다
          </span>
        </div>
        <div className="grid grid-cols-2 gap-[10px]">
          <MobileCard src="/assets/images/introduction/online.png" title="온라인 결제" />
          <MobileCard src="/assets/images/introduction/offline.png" title="현장결제" />
          <MobileCard src="/assets/images/introduction/keyin.png" title="수기결제" />
          <MobileCard src="/assets/images/introduction/billing.png" title="빌링결제" />
          <MobileCard
            src="/assets/images/introduction/ebpp.png"
            title="EBPP"
            text="문자, 알림톡, 링크결제"
          />
        </div>
      </div>
      <div
        className="hidden md:flex rounded-[24px] p-[3px]"
        style={{
          //  기본 회색 보더
          backgroundColor: "#DDE0E6",

          //  왼쪽 상단 + 오른쪽 상단 부분 그라데이션을 “바깥 배경”에만 그림
          backgroundImage: `
      conic-gradient(
        from 270deg,
        #0079FF 0deg,
        #00FF44 90deg,
        transparent 40deg,
        transparent 360deg
      ),
      conic-gradient(
        from 90deg,
        #0079FF 0deg,
        #00FF44 90deg,
        transparent 40deg,
        transparent 360deg
      )
    `,
          backgroundBlendMode: "normal",
        }}
      >
        <div className="flex flex-col rounded-[21px] bg-white  p-20 w-full">
          <div className="flex flex-col gap-3">
            <span className="font-bold md:text-display3_1 text-[20px]">
              품에서 제공하는 결제 서비스를 확인하세요
            </span>
            <span className="font-normal text-[18px] text-[#4D4F58]">
              온 오프라인 상관없이 유연하게 연결합니다
            </span>
          </div>

          <div className="flex flex-row w-full justify-around mt-[60px] md:gap-5 grid-cols-[repeat(auto-fit,minmax(180px,1fr))] min-w-0 md:grid">
            <IconCol src="/assets/images/introduction/online.png" service="온라인 결제" />
            <IconCol src="/assets/images/introduction/offline.png" service="현장결제" />
            <IconCol src="/assets/images/introduction/keyin.png" service="수기결제" />
            <IconCol src="/assets/images/introduction/billing.png" service="빌링결제" />
            <IconCol src="/assets/images/introduction/ebpp.png" service="EBPP" />
          </div>
        </div>
      </div>
    </div>
  );
};
